export default "__VITE_ASSET__CeO7rNjp__"